const carousels = async function () {
    const newsRelatedCarousel = document.querySelector(".news-related") !== null;
    const footerSwiper = document.querySelector(".footer-swiper") !== null;
    const featuredCarousel = document.querySelector(".featured-carousel") !== null;
    const portfolioCarousel = document.querySelector(".portfolio-hero-carousel") !== null;
    const triangleCarousel = document.querySelector(".triangle-carousel") !== null;
    const cardCarousel = document.querySelector(".card-carousel") !== null;

    if (
        newsRelatedCarousel ||
        footerSwiper ||
        featuredCarousel ||
        triangleCarousel ||
        cardCarousel ||
        portfolioCarousel
    ) {
        let Swiper = await (await import("swiper/bundle")).default;

        if (newsRelatedCarousel) {
            document.querySelectorAll(".news-related").forEach((section) => {
                const newsRelatedCarouselSwiper = new Swiper(
                    section.querySelector(".news-related-carousel"),
                    {
                        lazy: true,
                        loop: true,
                        slidesPerView: 1,
                        spaceBetween: 16,
                        watchSlidesProgress: true,
                        pagination: {
                            el: section.querySelector(".swiper-pagination"),
                            type: "fraction",
                        },
                        navigation: {
                            nextEl: section.querySelector(
                                ".swiper-button-next"
                            ),
                        },
                        breakpoints: {
                            768: {
                                slidesPerView: 2,
                                spaceBetween: 28,
                            },
                            1024: {
                                slidesPerView: 3,
                                spaceBetween: 25,
                            },
                        },
                    }
                );
            });
        }

        if (window.innerWidth <= 767) {
            const footerSwiperBox = new Swiper(".footer-swiper", {
                loop: true,
                slidesPerView: 1,
                spaceBetween: 25,
                watchSlidesProgress: true,
                pagination: {
                    el: ".swiper-pagination",
                    type: "fraction",
                },
                navigation: {
                    nextEl: ".swiper-button-next",
                },
            });
        }
        
        if ( featuredCarousel ) {
            const sections = document.querySelectorAll(".featured-carousel");
            
            sections.forEach(section => {
                const caption = section.querySelector(".featured-carousel__caption");
                
                const swiper = new Swiper(section.querySelector(".swiper"), {
                    loop: true,
                    speed: 600,
                    slidesPerView: 1,
                    autoplay: {
                        delay: 5000,
                        disableOnInteraction: false,
                    },
                    pagination: {
                        el: section.querySelector(".swiper-pagination"),
                        type: "fraction",
                    },
                    navigation: {
                        nextEl: section.querySelector(".swiper-button-next"),
                    },
                    on: {
                        slideChange: function () {
                            const content = this.el.querySelectorAll(".swiper-slide")[this.activeIndex].dataset.caption;
                            // caption.classList.add("fade");
                            caption.innerHTML = ( content !== '' ) ? content : "&nbsp;";

                            // setTimeout(() => {
                            //     caption.classList.remove("fade");
                            // }, 610);
                        }
                    }
                }); 
            });
        }

        if ( triangleCarousel ) {
            const sections = document.querySelectorAll(".triangle-carousel");

            sections.forEach((section) => {
                const speed = 600;

                // background
                const triangleCarouselBgSwiper = new Swiper(
                    section.querySelector(".triangle-carousel-bg"),
                    {
                        lazy: true,
                        slidesPerView: 1,
                        loop: true,
                        speed: speed,
                        watchSlidesProgress: true,
                    }
                );

                // content
                const triangleCarouselContentSwiper = new Swiper(
                    section.querySelector(".triangle-carousel-content"),
                    {
                        slidesPerView: 1,
                        loop: true,
                        speed: speed,
                        shortSwipes: false,
                        watchSlidesProgress: true,
                        effect: "fade",
                        fadeEffect: {
                            crossFade: true,
                        },
                    }
                );

                // pagination
                const updatePagination = (currentSlide) => {
                    const paginationText =
                        section.querySelector(".swiper-pagination");
                    const length = section
                        .querySelector(".triangle-carousel-content")
                        .querySelectorAll(
                            ".swiper-slide:not(.swiper-slide-duplicate)"
                        ).length;

                    paginationText.textContent = `${
                        currentSlide + 1
                    } / ${length}`;
                };

                // slide change
                triangleCarouselContentSwiper.on("slideChange", function () {
                    triangleCarouselBgSwiper.slideTo(
                        triangleCarouselContentSwiper.activeIndex,
                        speed,
                        false
                    );
                    updatePagination(triangleCarouselContentSwiper.realIndex);
                });

                triangleCarouselBgSwiper.on("slideChange", function () {
                    triangleCarouselContentSwiper.slideTo(
                        triangleCarouselBgSwiper.activeIndex,
                        speed,
                        false
                    );
                    updatePagination(triangleCarouselBgSwiper.realIndex);
                });

                // next slide button
                section
                    .querySelector(".swiper-button-next")
                    .addEventListener("click", () => {
                        triangleCarouselBgSwiper.slideNext(speed, false);
                        triangleCarouselContentSwiper.slideNext(speed, false);
                    });
            });
        }
        
        if ( portfolioCarousel ) {
            const desc = document.querySelector(".portfolio-hero-carousel-desc");
            const link = document.querySelector(".portfolio-hero-carousel-link");
            
            const cardCarouselSwiper = new Swiper(".portfolio-hero-carousel", {
                lazy: true,
                loop: true,
                slidesPerView: 1,
                speed: 600,
                pagination: {
                    el: ".portfolio-hero-carousel-pagination",
                    type: "fraction",
                },
                navigation: {
                    nextEl: ".portfolio-hero-carousel-next",
                },
                on: {
                    slideChange: function () {
                        const slide = this.el.querySelectorAll(".swiper-slide")[this.activeIndex];
                        
                        desc.innerHTML = ( slide.dataset.desc !== '' ) ? slide.dataset.desc : "&nbsp;";
                        link.querySelector(".portfolio-hero-carousel-link__text").innerHTML = ( slide.dataset.title !== '' ) ? slide.dataset.title : "&nbsp;";
                        link.setAttribute('href', slide.dataset.url);
                    }
                }
            });
        }
        
        if ( cardCarousel ) {
            const sections = document.querySelectorAll(".card-carousel");
            
            sections.forEach(section => {
                const swiper = new Swiper(section.querySelector(".swiper"), {
                    lazy: true,
                    loop: true,
                    slidesPerView: 1,
                    watchSlidesProgress: true,
                    shortSwipes: false,
                    pagination: {
                        el: section.querySelector('.swiper-pagination'),
                        type: "fraction",
                    },
                    navigation: {
                        nextEl: section.querySelector('.swiper-button-next'),
                    },
                    breakpoints: {
                        768: {
                            slidesPerView: 2,
                            spaceBetween: 28,
                            allowSlidePrev: section.classList.contains('full'),
                            allowSlideNext: section.classList.contains('full'),
                        },
                        1024: {
                            slidesPerView: section.classList.contains('full') ? 3 : 2,
                            spaceBetween: 25,
                            allowSlidePrev: false,
                            allowSlideNext: false,
                        },
                    },
                })
            })
        }
    }
};

export const init = carousels;
